<template>
  <div class="wizard-header w-100">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h4 class="modal-title mb-0">Crear Nuevo Documento</h4>
      <button
        type="button"
        class="close"
        aria-label="Cerrar"
        @click="$emit('close')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    
    <div class="wizard-stepper">
      <div
        v-for="step in totalSteps"
        :key="step"
        class="step"
        :class="{
          'active': step === currentStep,
          'completed': step < currentStep
        }"
      >
        <div class="step-number">
          <span v-if="step < currentStep">✓</span>
          <span v-else>{{ step }}</span>
        </div>
        <div class="step-label">
          {{ getStepLabel(step) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WizardHeader',
  props: {
    currentStep: {
      type: Number,
      required: true
    },
    totalSteps: {
      type: Number,
      default: 2
    }
  },
  methods: {
    getStepLabel(step) {
      const labels = {
        1: 'Seleccionar Tipo',
        2: 'Confirmar'
      };
      return labels[step] || `Paso ${step}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.wizard-header {
  .modal-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #2c3e50;
  }
  
  .close {
    font-size: 2rem;
    font-weight: 300;
    line-height: 1;
    color: #000;
    opacity: 0.5;
    background: transparent;
    border: 0;
    padding: 0;
    cursor: pointer;
    
    &:hover {
      opacity: 0.75;
    }
  }
}

.wizard-stepper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  padding-top: 1rem;
  
  .step {
    display: flex;
    flex-direction: column;
    align-items: center;
    opacity: 0.5;
    transition: opacity 0.3s ease;
    
    &.active,
    &.completed {
      opacity: 1;
    }
    
    .step-number {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 2px solid #ccc;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      margin-bottom: 0.5rem;
      transition: all 0.3s ease;
      background: white;
    }
    
    &.active .step-number {
      border-color: #7367f0;
      background-color: #7367f0;
      color: white;
    }
    
    &.completed .step-number {
      border-color: #28c76f;
      background-color: #28c76f;
      color: white;
    }
    
    .step-label {
      font-size: 0.875rem;
      font-weight: 500;
      color: #6c757d;
      text-align: center;
    }
    
    &.active .step-label {
      color: #7367f0;
      font-weight: 600;
    }
    
    &.completed .step-label {
      color: #28c76f;
    }
  }
}

@media (max-width: 576px) {
  .wizard-stepper {
    gap: 1rem;
    
    .step {
      .step-number {
        width: 35px;
        height: 35px;
        font-size: 0.875rem;
      }
      
      .step-label {
        font-size: 0.75rem;
      }
    }
  }
}
</style>
